import { isUserPermitted, Permissions, PermitRender, useUserState } from '@checkit/react-components';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './Dashboard.translations';
import { UnassignedCheckpoints } from './unassigned-checkpoints/UnassignedCheckpoints';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1
    }
  })
);

interface RenderableDashboardItem {
  component: React.FunctionComponent;
  permissions: Permissions;
}

const dashboardItems: RenderableDashboardItem[] = [
  { component: UnassignedCheckpoints,  permissions: { requiredFeatures: ['QR-SCANNING'] }}
];

export const Dashboard = () => {
  const classes = useStyles();
  const {formatMessage} = useIntl();
  const itemsCaption = formatMessage(messages['dashboard.itemsCaption']);
  const noItemsCaption = formatMessage(messages['dashboard.noItemsCaption']);
  const userState = useUserState();
  const anyItems = dashboardItems.filter(x => isUserPermitted(userState, x.permissions).permitted).length > 0;
  const Caption = () => {
    if (anyItems) {
      return (
        <Typography>
          {itemsCaption}
        </Typography>
      );
    }
    return (
      <Typography>
        {noItemsCaption}
      </Typography>
    );
  };
  return (
    <div data-testid="dashboard" className={classes.root}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12} md={12} lg={12}>
            <Caption />
        </Grid>
        <Grid item={true} xs={12} md={6} lg={2}>
          {dashboardItems.map((x, index) => {
            return (
              <PermitRender key={index} permissions={x.permissions} >
                <x.component key={index} />
              </PermitRender>
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
